import { BubbleMenu, Editor } from "@tiptap/react";
import { Divider } from "antd-v5";
import React, { useRef } from "react";

import ACDropdown from "ac-components/ACDropdown";
import ChevronDownIcon from "ac-components/ac-icons/ChevronDownIcon";
import TrashIcon from "ac-components/ac-icons/TrashIcon";

import "./ACTableBubbleMenu.less";

const prefixCls = "ac-table-bubble-menu";

enum Actions {
  INSERT_COLUMN_RIGHT,
  INSERT_ROW_BELOW,
  DELETE_COLUMN,
  DELETE_ROW,
  MERGE_CELLS,
  SPLIT_CELL,
}
export default function ACTableBubbleMenu({ editor }: { editor: Editor }) {
  const wrapperRef = useRef<HTMLDivElement | null>();
  if (!editor) {
    return null;
  }

  const optionClick = (value: number | string) => {
    const action = value as Actions;
    const commands = editor.chain().focus();
    let cmd;
    switch (action) {
      case Actions.INSERT_COLUMN_RIGHT:
        cmd = commands.addColumnAfter();
        break;
      case Actions.INSERT_ROW_BELOW:
        cmd = commands.addRowAfter();
        break;
      case Actions.MERGE_CELLS:
        cmd = commands.mergeCells();
        break;
      case Actions.SPLIT_CELL:
        cmd = commands.splitCell();
        break;
      case Actions.DELETE_COLUMN:
        cmd = commands.deleteColumn();
        break;
      default:
        cmd = commands.deleteRow();
        break;
    }
    if (cmd) {
      cmd.run();
    }
  };

  return (
    <BubbleMenu
      tippyOptions={{
        duration: 100,
        placement: "bottom",
        getReferenceClientRect: () => {
          const { state } = editor;
          const { $from } = state.selection;

          // Get the DOM node of the table
          // const tableNode = $from.node(-3);
          let tableElement;
          for (let i = -3; i <= -1; i++) {
            const element = editor.view.domAtPos($from.start(i))
              .node as HTMLTableElement;
            if (["TABLE", "TBODY", "TR"].includes(element.nodeName)) {
              tableElement = element;
              break;
            }
          }
          if (!tableElement) {
            tableElement = editor.view.domAtPos($from.start(-3))
              .node as HTMLTableElement;
          }
          // if (tableNode?.type.name === "table") {
          //   // Ensure it's an HTMLTableElement and return its bounding box
          //   if (tableElement instanceof HTMLTableElement) {
          //   }
          // }
          console.log(tableElement);
          return tableElement.getBoundingClientRect();

          // return null;
        },
      }}
      editor={editor}
      shouldShow={({ editor }) => editor.isActive("table")}
    >
      <div ref={(r) => (wrapperRef.current = r)} className={prefixCls}>
        <ACDropdown
          onOptionClick={optionClick}
          getPopupContainer={() => wrapperRef.current!}
          autoFocus={false}
          items={[
            {
              label: "Insert column right",
              value: Actions.INSERT_COLUMN_RIGHT,
              disabled: !editor.can().addColumnAfter(),
            },
            {
              label: "Insert row below",
              value: Actions.INSERT_ROW_BELOW,
              disabled: !editor.can().addRowAfter(),
            },
            {
              label: "Delete column",
              value: Actions.DELETE_COLUMN,
              disabled: !editor.can().deleteColumn(),
            },
            {
              label: "Delete row",
              value: Actions.DELETE_ROW,
              disabled: !editor.can().deleteRow(),
            },
            {
              label: "Merge cells",
              value: Actions.MERGE_CELLS,
              disabled: !editor.can().mergeCells(),
            },
            {
              label: "Split cell",
              value: Actions.SPLIT_CELL,
              disabled: !editor.can().splitCell(),
            },
          ]}
        >
          <span className="bubble-button d-flex align-items-center">
            options <ChevronDownIcon className="font-size-24" />
          </span>
        </ACDropdown>
        <Divider type="vertical" className="m-x-0" />
        <TrashIcon
          className="bubble-button"
          onClick={() => editor.chain().focus().deleteTable().run()}
        />
      </div>
    </BubbleMenu>
  );
}
